<style type="less" scoped>
    @import url('./css.less');
</style>
<template>
    <div class="container">
        <BusinessEchartBmap v-on:map-load="mapLoad" v-bind="$props" ref='map'>
        </BusinessEchartBmap>
    </div>
</template>

<script>
    import BusinessEchartBmap from './../common/businessEchartBmap/index';
    import BeiJingCountyPolygon from './../common/inMapOverlay/BeiJingCounty-Polygon';
    import mapPropsMinxin from './default-props-value';
    export default {
        name: '',
        props: {},
        mixins: [mapPropsMinxin],
        components: {
            BusinessEchartBmap
        },
        data() {
            return {
                
            }
        },
        watch: {
            
        },
        computed: {
            
        },
        methods: {
            mapLoad() {
                const mapComponent = this.$refs.map.getMapComponent();
                 
                var polygonOverlay = new BeiJingCountyPolygon();
                mapComponent.addInMapOverlay(polygonOverlay);

                const data = polygonOverlay.getValue();
                data.forEach((item) => {
                    item.count = 1; //默认
                });

                polygonOverlay.setValue([data]);
            }
        },
        mounted() {
            
        }
    }
</script>